/**
 * useBackofficeOffers
 * Fetches and manages list of offers from /backoffice/offers
 */
import { useQuery } from '@tanstack/react-query';
import { listOffers } from '@/services/credit-engine.service';
import { PARTNER_ID } from '@/constants';

export function useBackofficeOffers() {
  const query = useQuery({
    queryKey: ['backoffice', 'offers', PARTNER_ID],
    queryFn: () => listOffers(PARTNER_ID),
  });

  return {
    offers: query.data?.data ?? [],
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
}
